import script from "./NewCustomerNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./NewCustomerNumber.vue?vue&type=script&setup=true&lang=js"

import "./NewCustomerNumber.vue?vue&type=style&index=0&id=591fa334&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-591fa334"]])

export default __exports__